<template>
  <div class="home-game-tile" :class="{ 'home-game-tile--full': full }">
    <div class="home-game-cover" @click="$emit('click')">
      <img :src="src" alt="" />
      <span v-if="showBalance" class="home-game-balance">¥{{ balance }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeGameTile',
  props: {
    src: { type: String, required: true },
    balance: { type: [String, Number], default: '0.00' },
    showBalance: { type: Boolean, default: false },
    full: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.home-game-tile {
  width: 48%;
  margin-top: 10px;
  align-self: flex-start;

  &--full {
    width: 100%;
  }
}

.home-game-cover {
  position: relative;
  width: 100%;
  line-height: 0;
  font-size: 0;

  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 10px;
  }
}

.home-game-balance {
  position: absolute;
  right: 6px;
  bottom: 6px;
  z-index: 2;
  font-size: 11px;
  line-height: 1.2;
  color: #fff;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.6), 0 1px 2px rgba(0, 0, 0, 0.85);
  pointer-events: none;
  max-width: calc(100% - 12px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeGameTile.vue